/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_cat_converters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converters — units (length, weight, temperature, volume, area, speed, data, time), number bases, Roman numerals, colour formats, data sizes, text to binary and Morse code.`)
};

const es_about_cat_converters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversores — unidades (longitud, peso, temperatura, volumen, área, velocidad, datos, tiempo), bases numéricas, números romanos, formatos de color, tamaños de datos, texto a binario y código Morse.`)
};

const de_about_cat_converters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konverter — Einheiten (Länge, Gewicht, Temperatur, Volumen, Fläche, Geschwindigkeit, Daten, Zeit), Zahlensysteme, römische Zahlen, Farbformate, Datengrößen, Text zu Binär und Morsecode.`)
};

const nl_about_cat_converters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converters — eenheden (lengte, gewicht, temperatuur, volume, oppervlakte, snelheid, data, tijd), talstelsels, Romeinse cijfers, kleurformaten, datagroottes, tekst naar binair en morsecode.`)
};

const fr_about_cat_converters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseurs — unités (longueur, poids, température, volume, surface, vitesse, données, temps), bases numériques, chiffres romains, formats de couleur, tailles de données, texte en binaire et code Morse.`)
};

const it_about_cat_converters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitori — unità (lunghezza, peso, temperatura, volume, area, velocità, dati, tempo), basi numeriche, numeri romani, formati colore, dimensioni dei dati, testo in binario e codice Morse.`)
};

const pt_br2_about_cat_converters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversores — unidades (comprimento, peso, temperatura, volume, área, velocidade, dados, tempo), bases numéricas, algarismos romanos, formatos de cor, tamanhos de dados, texto para binário e código Morse.`)
};

const pt_about_cat_converters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversores — unidades (comprimento, peso, temperatura, volume, área, velocidade, dados, tempo), bases numéricas, algarismos romanos, formatos de cor, tamanhos de dados, texto para binário e código Morse.`)
};

const ja_about_cat_converters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変換ツール — 単位(長さ、重量、温度、体積、面積、速度、データ、時間)、進数、ローマ数字、色形式、データサイズ、テキストから2進数、モールス信号。`)
};

const zh_about_cat_converters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转换工具 — 单位(长度、重量、温度、体积、面积、速度、数据、时间)、进制、罗马数字、颜色格式、数据大小、文本转二进制以及摩斯电码。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_cat_converters = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_cat_converters(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_cat_converters", locale)
	if (locale === "en") return en_about_cat_converters(inputs)
	if (locale === "es") return es_about_cat_converters(inputs)
	if (locale === "de") return de_about_cat_converters(inputs)
	if (locale === "nl") return nl_about_cat_converters(inputs)
	if (locale === "fr") return fr_about_cat_converters(inputs)
	if (locale === "it") return it_about_cat_converters(inputs)
	if (locale === "pt-BR") return pt_br2_about_cat_converters(inputs)
	if (locale === "pt") return pt_about_cat_converters(inputs)
	if (locale === "ja") return ja_about_cat_converters(inputs)
	return zh_about_cat_converters(inputs)
};